export enum EAccountOrganizationRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  WRITER = 'writer',
  READER = 'reader',
  UNREGISTERED = 'unregistered',
}
